import { Col, Row } from "react-bootstrap";
import moment from "moment/min/moment-with-locales";

export default function ScheduleCheckSongsRow({ item, virtualizer, virtualRow }) {
    return (
        <Row
            data-index={virtualRow.index}
            ref={virtualizer.measureElement}
            style={{ transform: `translateY(${virtualRow.start - virtualizer.options.scrollMargin}px)` }}
            className={`py-1 border-bottom position-absolute w-100 py-1 bg-opacity-50 ${
                !item.scheduled_start && item.logged_start ? "bg-success" : item.scheduled_start && !item.logged_start ? "bg-danger" : ""
            }`}>
            <Col xs className=" d-none d-xl-block">
                {item.artist}
            </Col>
            <Col xs className=" d-none d-xl-block">
                {item.title}
            </Col>
            <Col xs={12} className=" align-content-center d-xl-none text-capitalize">
                <Row className="gx-1">
                    <Col xs={"auto"}>
                        <span className="fw-bold fw-xl-normal">{item.artist}</span>
                    </Col>
                    <Col xs={"auto"}>
                        <span className="fw-bold fw-xl-normal">-</span>
                    </Col>
                    <Col xs={"auto"}>
                        <span className="fw-bold fw-xl-normal">{item.title}</span>
                    </Col>
                </Row>
            </Col>
            <Col xs={"auto"} xl={2} className=" align-content-center text-center">
                <span className=" d-xl-none">Scheduled: </span>
                <span className=" fw-bold fw-xl-normal">{item.scheduled_start ? moment(item.scheduled_start).format("LTS") : "-"}</span>
            </Col>
            <Col xs={"auto"} xl={2} className=" align-content-center text-center">
                <span className=" d-xl-none">Played: </span>
                <span className=" fw-bold fw-xl-normal">{item.logged_start ? moment(item.logged_start).format("LTS") : "-"}</span>
            </Col>
        </Row>
    );
}
